import { useQuery } from '@tanstack/react-query';
import { SmsUsageStatus } from '@cloudsign/shared';
import { api } from '../../lib/api';
import { formatNumber } from '../../lib/format';
import { t } from '../../lib/i18n';

/** Read-only "Text messages this month: used of limit" line for the tenant billing page. Shows nothing if the module is off or not allowed. */
export function SmsUsageLine() {
  const q = useQuery({ queryKey: ['notifications', 'sms-usage'], queryFn: () => api.get('/notifications/sms-usage', { schema: SmsUsageStatus }), retry: false });
  if (!q.data) return null;
  const { limit, used } = q.data;
  return (
    <p className="mb-5 text-sm text-slate-700">
      {limit > 0 ? t('sms.usage.line', { used: formatNumber(used), limit: formatNumber(limit) }) : t('sms.usage.none')}
    </p>
  );
}
